import { Box, Stack } from '@mui/material'
import CustomText from 'components/common/CustomText/CustomText'
import useGlobalStyles from 'styles/globalStyles'
import ReimbursementOptions from './ReimbursementOptions'
import { useCallback } from 'react'
import { useProfileContext } from 'context/ProfileContext'
import { showAmount, showRVUMultiplier, showThreshold } from 'common/caseHelpers'

export default function ReimbursementItem() {
  const { reimbursement } = useProfileContext();
  const globalStyles = useGlobalStyles();

  const renderItem = useCallback(({ title, value }: any) => {
    return (
      <Stack
        direction={'row'}
        alignItems={'center'}
      >
        <CustomText text={title} fontWeight={600} />
        <CustomText text={value} sx={{ ml: 1 }} />
      </Stack>
    )
  }, []);

  return (
    <Box
      className={globalStyles.reimbursementItemContainer}
      display="flex"
      justifyContent={'space-between'}
      alignItems={'flex-start'}
    >
      <Box
        display="flex"
        flexDirection="column"
      >

        {/* Practice state */}
        <Box>
          {renderItem({
            title: 'Practice state:',
            value: reimbursement.practice_state,
          })}
        </Box>

        {/* Reimbursement model */}
        <Box>
          {renderItem({
            title: 'Reimbursement model:',
            value: reimbursement.reimbursement_model,
          })}
        </Box>

        {/* Threshold */}
        {showThreshold(reimbursement.reimbursement_model) && <Box>
          {renderItem({
            title: 'Threshold:',
            value: reimbursement.threshold,
          })}
        </Box>}

        {/* Amount */}
        {showAmount(reimbursement.reimbursement_model) && <Box>
          {renderItem({
            title: 'Amount:',
            value: reimbursement.amount,
          })}
        </Box>}

        {/* RVUs Multiplier */}
        {showRVUMultiplier(reimbursement.reimbursement_model) && <Box>
          {renderItem({
            title: 'RVUs multiplier:',
            value: `${reimbursement.rvus_multiplier}$`,
          })}
        </Box>}

      </Box>

      <ReimbursementOptions />
    </Box>
  )
}
